import {
  StatusOK,
  StatusError,
  StatusWarning,
} from '@backstage/core-components';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { StatusType } from '../types/deployment.ts';
import React from 'react';

export const getStatusIcon = (type: StatusType) => {
  switch (type) {
    case 'success':
      return <StatusOK />;
    case 'error':
      return <StatusError />;
    case 'warning':
      return <StatusWarning />;
    default:
      return <CheckCircleIcon />;
  }
};

export const getStatusColor = (type: StatusType): string => {
  switch (type) {
    case 'success':
      return '#4caf50';
    case 'error':
      return '#f44336';
    case 'warning':
      return '#ff9800';
    default:
      return '#4caf50';
  }
};

export const getChangeTypeColor = (type?: string): string => {
  switch (type) {
    case 'feature':
      return '#2196f3';
    case 'bugfix':
      return '#f44336';
    case 'enhancement':
      return '#4caf50';
    case 'security':
      return '#ff9800';
    default:
      return '#757575';
  }
};
